import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { useAuth } from "@/contexts/AuthContext";
import { toast } from "sonner";

export default function Auth() {
  const { login, register, loginWithGoogle } = useAuth();
  const nav = useNavigate();
  const [mode, setMode] = useState("login");
  const [form, setForm] = useState({ email: "", password: "", name: "" });
  const [busy, setBusy] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setBusy(true);
    try {
      if (mode === "login") await login(form.email, form.password);
      else await register(form.email, form.password, form.name);
      toast.success("Welcome!");
      nav("/account");
    } catch (er) {
      toast.error(er?.response?.data?.detail || "Failed");
    } finally { setBusy(false); }
  };

  return (
    <div className="max-w-md mx-auto px-6 py-20" data-testid="auth-page">
      <h1 className="font-display text-5xl text-[color:var(--hb-navy)] text-center">{mode === "login" ? "Sign In" : "Create Account"}</h1>
      <p className="text-center text-xs uppercase tracking-widest text-neutral-500 mt-2">Hampton Blu Family</p>

      <button onClick={loginWithGoogle} className="mt-8 w-full border border-neutral-300 py-3 flex items-center justify-center gap-3 text-sm hover:border-[color:var(--hb-navy)]" data-testid="google-login-btn">
        <svg width="18" height="18" viewBox="0 0 48 48"><path fill="#EA4335" d="M24 9.5c3.5 0 6.4 1.2 8.8 3.5l6.5-6.5C35.4 3 30.1 1 24 1 14.8 1 6.9 6.3 3.1 14l7.6 5.9C12.5 13.7 17.8 9.5 24 9.5z"/><path fill="#4285F4" d="M46.5 24.5c0-1.6-.1-3.2-.4-4.7H24v9h12.7c-.6 3-2.3 5.6-5 7.3l7.6 5.9c4.5-4.2 7.2-10.3 7.2-17.5z"/><path fill="#FBBC05" d="M10.7 28.9c-.6-1.7-.9-3.5-.9-5.4s.3-3.7.9-5.4L3.1 12.2C1.1 16 0 20.4 0 25s1.1 9 3.1 12.8l7.6-5.9z"/><path fill="#34A853" d="M24 49c6.1 0 11.4-2 15.2-5.4l-7.6-5.9c-2.1 1.4-4.8 2.3-7.6 2.3-6.2 0-11.5-4.2-13.3-9.9l-7.6 5.9C6.9 43.7 14.8 49 24 49z"/></svg>
        Continue with Google
      </button>

      <div className="my-6 text-center text-xs text-neutral-400 uppercase tracking-widest">or</div>

      <form onSubmit={submit} className="space-y-4" data-testid="auth-form">
        {mode === "register" && (
          <input placeholder="Name" value={form.name} onChange={e=>setForm({...form,name:e.target.value})} required
            className="w-full border-b border-neutral-300 py-3 focus:outline-none focus:border-[color:var(--hb-navy)]" data-testid="auth-name"/>
        )}
        <input type="email" placeholder="Email" value={form.email} onChange={e=>setForm({...form,email:e.target.value})} required
          className="w-full border-b border-neutral-300 py-3 focus:outline-none focus:border-[color:var(--hb-navy)]" data-testid="auth-email"/>
        <input type="password" placeholder="Password" value={form.password} onChange={e=>setForm({...form,password:e.target.value})} required
          className="w-full border-b border-neutral-300 py-3 focus:outline-none focus:border-[color:var(--hb-navy)]" data-testid="auth-password"/>
        <button disabled={busy} className="hb-btn-primary w-full mt-4" data-testid="auth-submit">
          {busy ? "…" : mode === "login" ? "Sign In" : "Create Account"}
        </button>
      </form>

      <div className="text-center mt-6 text-sm">
        {mode === "login" ? (
          <>New here? <button onClick={()=>setMode("register")} className="underline" data-testid="switch-register">Create an account</button></>
        ) : (
          <>Have an account? <button onClick={()=>setMode("login")} className="underline" data-testid="switch-login">Sign in</button></>
        )}
      </div>
    </div>
  );
}
